import { BKJTimeInput } from '@bookjane2/bookjane-design-library';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { IShiftTimeSelectInputProps } from './ShiftTimeSelectInput.types';
import isUserTimeFormat24hSelector from 'store/selectors/userSelectors/isUserTimeFormat24hSelector';

export const ShiftTimeSelectInput: FC<IShiftTimeSelectInputProps> = ({
  name,
  disabled = false,
  placeholder,
  value,
  onChange,
  label,
  error,
  id,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
}) => {
  const isUserTimeFormat24h = useSelector(isUserTimeFormat24hSelector);

  return (
    <BKJTimeInput
      leftIconProps={{ iconName: 'ShiftsTime' }}
      disabled={disabled}
      error={error}
      label={label}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      type="Single"
      action="OpenToggle"
      is24hFormat={isUserTimeFormat24h}
      id={id}
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedBy}
    />
  );
};
